import { render, staticRenderFns } from "./CandidateInviteMethods.vue?vue&type=template&id=476a0c5a&scoped=true&"
import script from "./CandidateInviteMethods.vue?vue&type=script&lang=js&"
export * from "./CandidateInviteMethods.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInviteMethods.vue?vue&type=style&index=0&id=476a0c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a0c5a",
  null
  
)

/* custom blocks */
import block0 from "./CandidateInviteMethods.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateInviteMethods.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
